import moment from 'moment';
import { SUBSCRIPTION_STATUS } from '../constants/tenantConstants';
var SESSION_REPLAY_FIRST_DAY_HOURS = 24;
var isSessionReplayEnabledForBuild = function isSessionReplayEnabledForBuild() {
    return process.env.MIXPANEL_SESSION_REPLAY_ENABLED === 'true';
};
var isFreeTenant = function isFreeTenant(user) {
    var _user_tenant;
    return (user === null || user === void 0 ? void 0 : (_user_tenant = user.tenant) === null || _user_tenant === void 0 ? void 0 : _user_tenant.subscriptionStatus) === SUBSCRIPTION_STATUS.FREE;
};
var isWithinFirstDay = function isWithinFirstDay(user) {
    // moment(undefined) is "now", so a missing createdAt would look brand new.
    if (!(user === null || user === void 0 ? void 0 : user.createdAt)) return false;
    var createdAt = moment(user.createdAt);
    if (!createdAt.isValid()) return false;
    var ageHours = moment().diff(createdAt, 'hours', true);
    return ageHours >= 0 && ageHours < SESSION_REPLAY_FIRST_DAY_HOURS;
};
export var shouldRecordSession = function shouldRecordSession(user) {
    return isSessionReplayEnabledForBuild() && isFreeTenant(user) && isWithinFirstDay(user);
};
